import React from "react";
import { mfaFlow } from "utils/enum";

import { stylize } from "@envestnet/envreact-component-library";
import AuthenticatorHeader from "components/AuthenticatorHeader";
import EnvAuthenticatorStepOne from "components/EnvAuthenticatorStepOne";
import EnvAuthenticatorStepThree from "components/EnvAuthenticatorStepThree";
import EnvAuthenticatorStepTwo from "components/EnvAuthenticatorStepTwo";
import Logo from "images/Logo";
import withIntl from "utils/withIntl";
import { AppTypeEnum, EnvAuthenticatorStatusEnum } from "./enums";
import styles from "./styles";
import { SubmissionStateType } from "./types";

type DefaultProps = {};

interface EnvAuthProps {
  hideLogo: boolean;
  activeStep: number;
  redirectToMfa: () => void;
  setActiveStep: (step: number) => void;
  authenticatorName: string;
  loadQrCode: (obj: {
    authenticatorType: string;
    currentLayout: mfaFlow;
  }) => void;
  submitPasscode: () => void;
  loadStatus: (obj: { authenticatorType: any }) => void;
  resetSubmissionStatus: () => void;
  loadingPasscodeSubmission: SubmissionStateType;
  qrCodeImg: string;
  status: EnvAuthenticatorStatusEnum;
  secretCode: string;
  username: string;
  currentLayout: mfaFlow;
}

type Props = EnvAuthProps & DefaultProps;

const EnvAuth = (props: Props) => {
  const {
    hideLogo,
    activeStep,
    authenticatorName,
    currentLayout,
    loadQrCode,
    loadStatus,
    loadingPasscodeSubmission,
    qrCodeImg,
    redirectToMfa,
    resetSubmissionStatus,
    secretCode,
    setActiveStep,
    status,
    submitPasscode,
    username,
  } = props;

  return (
    <>
      {!hideLogo && <Logo />}
      <AuthenticatorHeader
        authenticatorName={authenticatorName}
        userId={username}
      />
      {activeStep === 1 && (
        <EnvAuthenticatorStepOne
          onNext={() => loadStatus({ authenticatorType: AppTypeEnum.APP })}
          onCancel={redirectToMfa}
          loadQrCode={loadQrCode}
          currentLayout={currentLayout}
          qrCodeImg={qrCodeImg}
          status={status}
          onCantScan={() => {
            setActiveStep(3);
          }}
        />
      )}
      {activeStep === 2 && (
        <EnvAuthenticatorStepTwo
          onCancel={redirectToMfa}
          onBack={() => setActiveStep(1)}
          onSubmitPassCode={submitPasscode}
          status={loadingPasscodeSubmission}
          resetSubmissionStatus={resetSubmissionStatus}
        />
      )}
      {activeStep === 3 && (
        <EnvAuthenticatorStepThree
          onNext={() => loadStatus({ authenticatorType: AppTypeEnum.APP })}
          status={status}
          secretCode={secretCode}
          onCancel={redirectToMfa}
        />
      )}
    </>
  );
};

export default withIntl(stylize<Props, DefaultProps>(styles)(EnvAuth));
